<template>
    <v-dialog
        v-if="visible"
        v-model="visible"
        transition="dialog-top-transition"
        persistent
        max-width="600"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
                <v-form class="wrapperFormModal">
                    <v-card flat>
                        <v-card-text v-if="loading">
                            <v-col class="text-subtitle-1 text-center" cols="12">
                                {{ $t("Загрузка...") }}
                            </v-col>
                            <v-col cols="12">
                                <v-progress-linear color="#a94442" indeterminate rounded height="6" />
                            </v-col>
                        </v-card-text>
                        <v-card-text v-else>                            
                            <div class="form-box-title title-with-right-part">
                                <span>
                                    {{ $t("Доступно") }}
                                </span>
                                <div class="twrp-content">
                                    <v-text-field
                                        v-model="search"
                                        :placeholder="$t('Поиск')"
                                        hide-details
                                        dense
                                        clearable
                                        required
                                        @click:clear="search = null"
                                        class="twrp-search"
                                        append-icon="fas fa-search"
                                    >
                                    </v-text-field>
                                </div>
                            </div>

                            <v-virtual-scroll
                                v-if="visibleItems.length > 0"
                                :items="visibleItems"
                                item-height="40"
                                height="400"
                                bench="10"
                                class="virt-scrl-list-tree"
                            >
                                <template v-slot:default="{ item, index }">
                                    <v-list-item
                                        :key="index"
                                        @click="onItemClick(item)"
                                        :style="{ marginLeft: '0px' }"
                                        v-ripple="{ class: `primary--text` }"
                                    >
                                        <v-list-item-action 
                                            :class="['']"
                                        >
                                            <v-checkbox
                                                color="primary"
                                                hide-details
                                                class="p-0"
                                                :input-value="item == selected"
                                                @click.native.capture="onItemSelect(item, $event)"
                                            >
                                            </v-checkbox>
                                        </v-list-item-action>

                                        <v-list-item-icon>
                                            <v-icon
                                                :color="item.id == null ? '' : 'green darken-2'"
                                                small
                                            >
                                                fas fa-file-alt
                                            </v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <div class="d-flex">
                                                    <div class="d-flex align-center flex-grow-1">
                                                        <div class="etw-text-container" v-tooltip.top-center='item.name'>
                                                            <span class="etw-text text-uppercase">{{item.name}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                </template>
                            </v-virtual-scroll>
                            <div v-else class="div-table-row">
                                <div class="cfl-placeholder">{{$t("К_сожалению,_по_Вашему_запросу_ничего_не_найдено")}}</div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    v-if="isValidForSave"
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                >
                    {{ $t("Выбрать") }}
                </v-btn>

                <v-btn 
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Закрыть") }}
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
import sys from '@/services/system';

export default {
    name: "SelectWorkFlowSchemeDlg",
    computed: {
        visibleItems() {
            return this.$_.orderBy(this.data.filter(x => x.visible), ['score', (item) => { return item.name }], ['desc', 'asc']);
        },
        isValidForSave() {
            return this.selected != null;
        }
    },
    data: () => ({
        title: "Схемы_бизнес-процессов",
        visible: false,
        resolve: null,

        loading: true,
        search: null,
        data: [],
        selected: null,

        options: {}
    }),
    methods: {
        async open(selected, options = {}) {
            this.reset();
            this.visible = true;
            this.options = Object.assign(this.options, options);

            await this.loadData(selected);
            this.loading = false;

            return new Promise((resolve) => { this.resolve = resolve; });
        },
        async loadData(selectedId) {
            let filterJson = JSON.stringify({ 
                SearchStr: null,
                OrderBy: 3,
                OrderDir: false,
                EnterpriseId: this.$store.getters['global/auth/getUserInfo']?.EnterpriseId ?? null,
                ShowParams: true,
                IncludeDefault: ['2bf2c5d4-a4d2-4f38-b23d-b71131e44e8b'],
                ContextTypes: ['Avrora.Objects.Modules.Docflow.DocflowObjects.InnerDocument']
            });

            let response = await httpAPI({
                url: `api/document-templates/list?collection=Workflows&filter=${filterJson}`,
                method: 'GET',
                headers: { 'isCommon': false },
            });

            let rawArray = response?.data?.Payload?.data ?? [];
            this.data = rawArray.map(x => ({ ...x, visible: true }));
            this.selected = this.data.find(x => x.id == selectedId) ?? null;
        },
        applySearch(searchStr) {
            let isEmpty = searchStr == null || searchStr.trim().length == 0;

            if (isEmpty) {
                for (let item of this.data) {
                    item.score = 0;
                    item.visible = true;
                }
                
                return;
            }

            for (let item of this.data) {
                item.visible = sys.checkSearchWithScore(searchStr, item, 'name');
            }
        },
        onItemClick(item) {
            if (!item) return;

            this.onItemSelect(item, null);
            return;
        },
        onItemSelect(item, event) {
            if (!item) return;

            let scheme = this.data.find(x => x.id == item.id && item.parent == x.parent);

            if (!scheme) return;

            this.selected = scheme;
            
            if (event)
                event.stopPropagation();
        },
        ok() {
            this.visible = false;
            this.resolve(this.selected);
        },
        cancel() {
            this.visible = false;
            this.resolve(null);
        },
        reset() {
            this.loading = true;
            this.search = null;
            this.selected = null;
        }
    },
    watch: {
        search(v) {
            this.applySearch(v);
        }
    }
}
</script>